import { Select } from '../../../components/Select'
import { Props } from '../../../components/Select/types'

type DashboardFilterSelectProps = Props & {
  isMulti: boolean
}

const toSingleSelectValue = (value?: string[]) => value?.[0]

const toMultiSelectValue = (value?: string): string[] => (value ? [value] : [])

export const DashboardFilterSelect = ({
  isMulti,
  propsSelect,
  propsItem,
  ...rest
}: DashboardFilterSelectProps) => {
  const SelectComponent = isMulti ? Select.Multi : Select.Default

  const adaptedPropsSelect =
    isMulti || !propsSelect
      ? propsSelect
      : {
          ...propsSelect,
          value: toSingleSelectValue(propsSelect.value as string[] | undefined),
          onChange: propsSelect.onChange
            ? (value: string) =>
                (propsSelect.onChange as (value: string[]) => void)(
                  toMultiSelectValue(value)
                )
            : undefined
        }

  const adaptedPropsItem =
    isMulti || !propsItem
      ? propsItem
      : {
          ...propsItem,
          getValueFromEvent: (value: string) => toMultiSelectValue(value),
          getValueProps: (value: string[]) => ({
            value: toSingleSelectValue(value)
          })
        }

  return (
    <SelectComponent
      {...rest}
      propsSelect={adaptedPropsSelect}
      propsItem={adaptedPropsItem}
    />
  )
}
